"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let CloumnListModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.columns = new Array();
  }
};
CloumnListModel.model = "column_list";
CloumnListModel = __decorateClass([
  Annotation.ModelMeta
], CloumnListModel);
export let CloumnModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.cn_name = "";
    this.is_del = "";
    this.en_name = "";
    this.remark = "";
    this.sort = "";
    this.columon = "";
    this.is_show = "";
  }
};
CloumnModel.model = "custom.column";
CloumnModel = __decorateClass([
  Annotation.ModelMeta
], CloumnModel);
